<script lang="ts">
  import { onMount } from "svelte"
  import { init } from "./services"
  import { activeFlowItems, disabledFlowItems } from './store'

  import GeneralLayout from "../../layouts/GeneralLayout.svelte"
  import Accordion from "./components/Accordion/Accordion.svelte"
  import TopPanel from "./components/TopPanel/TopPanel.svelte"
  import ProgressBar from "./components/ProgressBar/ProgressBar.svelte"

  onMount(init)
</script>

<GeneralLayout>
  <TopPanel />
  <ProgressBar />
  
  {#each $activeFlowItems as item (item.pk)}
    <Accordion {item} />
  {/each}

  <hr />

  {#each $disabledFlowItems as item (item.pk)}
    <Accordion {item} />
  {/each}
</GeneralLayout>